module.exports = __webpack_public_path__ + "static/media/bg_04.7a21244f.jpg";